import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    pagoDatos: [],
    pagoPersonal: [],
    pagoDocumentos: [],
    pagoTransferencias: [],
    pagoChequesPropios: []
};

const mutations = {
    updateField,

    'INICIALIZAR_DATOS' (state) {
        state.pagoDatos = [];
        state.pagoPersonal = [];
        state.pagoDocumentos = [];
        state.pagoTransferencias = [];
        state.pagoChequesPropios = [];
    },
    'SET_DATOS' (state, params) {
        state.pagoDatos = params.pagoDatos;
        state.pagoPersonal = params.pagoPersonal;
        state.pagoDocumentos = params.pagoDocumentos;
        state.pagoTransferencias = params.pagoTransferencias;
        state.pagoChequesPropios = params.pagoChequesPropios;
    }
};

const getters = {
    getField,
};

const actions = {
    getDatos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            apiAxios.get(`liquidaciones-sueldos/${params.liquidacionSueldosId}/pago/${params.liquidacionSueldosPagoId}`)
                .then(res => {
                    let pagoDatos = [
                        { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                        // { 'nombre': 'fechaContable', 'campo': 'Fecha Contable', 'valor': res.data.fechaContable, 'formato': 'fecha' },
                        { 'nombre': 'total', 'campo': 'Total', 'valor': res.data.total, 'formato': 'importe' },
                        { 'nombre': 'usuario', 'campo': 'Usuario', 'valor': res.data.usuario, 'formato': '' },
                        // { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones.trim(), 'formato': '' },
                    ]

                    let paramsDatos = {
                        pagoDatos,
                        pagoPersonal: res.data.personal,
                        pagoDocumentos: res.data.documentos,
                        pagoTransferencias: res.data.transferencias,
                        pagoChequesPropios: res.data.chequesPropios
                    }
                                    
                    commit('SET_DATOS', paramsDatos);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}